import React from "react";
import { BadgeComponents } from "@dishopsaas/design-system";
import { CartProps } from "../../../1_types/InfoBarTypes";
import { BLACK } from "../../../constants";
import { Box } from "@mui/material";

export const CartBadge: React.FC<CartProps> = ({ count, onClick, icon, disabled }) => (
  <Box sx={{ width: "48px", cursor: disabled ? 'not-allowed' : "pointer" }} onClick={onClick}>
    <BadgeComponents.CounterBadge
      content={count || 0}
      color={count ? "primary" : BLACK}
      showZero
    >
      <BadgeComponents.Placeholder icon={icon} />
    </BadgeComponents.CounterBadge>
  </Box>
);
